<span class="form-input-text-area">
  <label [htmlFor]="id" [innerHTML]="label ? label : ('field.'+ field) | translate" class="input-label"
    *ngIf="label || field" [hidden]="noLabel"></label>
  <textarea pTextarea [id]="id" (input)="onInput($event)" [value]="formControl['value']"
    [disabled]="formControl['disabled']" [placeholder]="placeholder || ''" 
    [rows]="rows" fluid [readonly]="readonly"
    [ngClass]="{ 'disabled': formControl['disabled'] || readonly }"></textarea>
  <app-form-input-error [show]="formControl.invalid && (formControl.dirty || formControl.touched)"
    [required]="formControl.errors?.['required']"></app-form-input-error>
</span>
